"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@opensea/ui-kit";
import { createContext, useCallback, useContext, useMemo } from "react";
import { getChainLogo } from "../chains/chain-logos";
import { getChainRpcUrls } from "../chains/utils";
export const ChainsContext = createContext({
  chains: []
});
export const useChains = () => {
  const $ = _c(56);
  const {
    chains
  } = useContext(ChainsContext);
  const {
    theme
  } = useTheme();
  let t0;
  let t1;
  if ($[0] !== chains) {
    t1 = chains.filter(_temp);
    $[0] = chains;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const evmChains = t0;
  let t2;
  let t3;
  if ($[2] !== chains) {
    t3 = chains.filter(_temp2);
    $[2] = chains;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  t2 = t3;
  const svmChains = t2;
  let t4;
  let t5;
  if ($[4] !== chains) {
    t5 = chains.reduce(_temp3, {});
    $[4] = chains;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  t4 = t5;
  const chainByIdentifier = t4;
  let t6;
  if ($[6] !== chains) {
    t6 = identifier => chains.find(c => c.identifier === identifier);
    $[6] = chains;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const getChain = t6;
  let t7;
  if ($[8] !== getChain) {
    t7 = identifier_0 => {
      const chain_1 = getChain(identifier_0);
      if (!chain_1) {
        throw new Error(`Chain ${identifier_0} not found`);
      }
      return chain_1;
    };
    $[8] = getChain;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const getChainStrict = t7;
  let t8;
  if ($[10] !== chainByIdentifier) {
    t8 = chainId => chainByIdentifier[chainId]?.onlyCurrencySupport ?? false;
    $[10] = chainByIdentifier;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const isChainCurrencyOnly = t8;
  let t9;
  if ($[12] !== chainByIdentifier) {
    t9 = chain_2 => chainByIdentifier[chain_2]?.name || "Unknown";
    $[12] = chainByIdentifier;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const getChainName = t9;
  let t10;
  if ($[14] !== chainByIdentifier) {
    t10 = chain_3 => chainByIdentifier[chain_3]?.listingCurrency ?? chainByIdentifier.ethereum?.listingCurrency;
    $[14] = chainByIdentifier;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const getChainListingCurrency = t10;
  let t11;
  if ($[16] !== chainByIdentifier) {
    t11 = chain_4 => chainByIdentifier[chain_4]?.offerCurrency ?? chainByIdentifier.ethereum?.offerCurrency;
    $[16] = chainByIdentifier;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const getChainOfferCurrency = t11;
  let t12;
  if ($[18] !== getChain || $[19] !== theme) {
    t12 = (identifier_1, t13) => {
      const options = t13 === undefined ? {} : t13;
      const chain_5 = getChain(identifier_1);
      return getChainLogo(identifier_1, theme, chain_5, options);
    };
    $[18] = getChain;
    $[19] = theme;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const getLogo = t12;
  let t13;
  if ($[21] !== chains) {
    t13 = (chainId_0, chainArch) => {
      const chain_6 = chains.find(c_0 => c_0.networkId === chainId_0 && c_0.arch === chainArch);
      return chain_6?.identifier;
    };
    $[21] = chains;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const getChainIdentifier = t13;
  let t14;
  if ($[23] !== getChainStrict) {
    t14 = chainIdentifier => getChainStrict(chainIdentifier).networkId;
    $[23] = getChainStrict;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const getChainId = t14;
  let t15;
  if ($[25] !== getChain) {
    t15 = identifier_2 => {
      const chainInfo = getChain(identifier_2);
      return chainInfo?.name ?? identifier_2;
    };
    $[25] = getChain;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const getName = t15;
  let t16;
  if ($[27] !== getChainStrict) {
    t16 = identifier_3 => {
      const currency = getChainStrict(identifier_3).nativeCurrency;
      return currency;
    };
    $[27] = getChainStrict;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const getNativeCurrency = t16;
  let t17;
  if ($[29] !== getChainStrict) {
    t17 = identifier_4 => {
      const currency_0 = getChainStrict(identifier_4).listingCurrency;
      return currency_0;
    };
    $[29] = getChainStrict;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  const getListingCurrency = t17;
  let t18;
  if ($[31] !== getChainStrict) {
    t18 = identifier_5 => {
      const currency_1 = getChainStrict(identifier_5).offerCurrency;
      return currency_1;
    };
    $[31] = getChainStrict;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const getOfferCurrency = t18;
  let t19;
  if ($[33] !== getChainStrict) {
    t19 = identifier_6 => {
      const chain_7 = getChainStrict(identifier_6);
      if (!chain_7.wrappedNativeCurrency) {
        return;
      }
      const currency_2 = chain_7.wrappedNativeCurrency;
      return currency_2;
    };
    $[33] = getChainStrict;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const getWrappedNativeCurrency = t19;
  let t20;
  if ($[35] !== getChain) {
    t20 = identifier_7 => {
      const chain_8 = getChain(identifier_7);
      if (!chain_8) {
        return [];
      }
      return getChainRpcUrls(chain_8);
    };
    $[35] = getChain;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const getRpcUrls = t20;
  let t21;
  if ($[37] !== chains || $[38] !== evmChains || $[39] !== getChain || $[40] !== getChainId || $[41] !== getChainIdentifier || $[42] !== getChainListingCurrency || $[43] !== getChainName || $[44] !== getChainOfferCurrency || $[45] !== getChainStrict || $[46] !== getListingCurrency || $[47] !== getLogo || $[48] !== getName || $[49] !== getNativeCurrency || $[50] !== getOfferCurrency || $[51] !== getRpcUrls || $[52] !== getWrappedNativeCurrency || $[53] !== isChainCurrencyOnly || $[54] !== svmChains) {
    t21 = {
      chains,
      allChains: chains,
      svmChains,
      evmChains,
      getChain,
      getChainStrict,
      getChainIdentifier,
      getChainId,
      getLogo,
      getName,
      getChainName,
      getNativeCurrency,
      getWrappedNativeCurrency,
      getListingCurrency,
      getOfferCurrency,
      getRpcUrls,
      isChainCurrencyOnly,
      getChainListingCurrency,
      getChainOfferCurrency
    };
    $[37] = chains;
    $[38] = evmChains;
    $[39] = getChain;
    $[40] = getChainId;
    $[41] = getChainIdentifier;
    $[42] = getChainListingCurrency;
    $[43] = getChainName;
    $[44] = getChainOfferCurrency;
    $[45] = getChainStrict;
    $[46] = getListingCurrency;
    $[47] = getLogo;
    $[48] = getName;
    $[49] = getNativeCurrency;
    $[50] = getOfferCurrency;
    $[51] = getRpcUrls;
    $[52] = getWrappedNativeCurrency;
    $[53] = isChainCurrencyOnly;
    $[54] = svmChains;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  return t21;
};
function _temp(chain) {
  return chain.arch === "EVM";
}
function _temp2(chain_0) {
  return chain_0.arch === "SVM";
}
function _temp3(acc, curr) {
  acc[curr.identifier] = curr;
  return acc;
}